const features = [
  {
    icon: 'ri-font-family',
    title: '海量字体库',
    description: '超过500款精选中英文字体，涵盖手写体、书法体、艺术体等多种风格，每月持续更新，让你的文字表达更加丰富多彩。',
  },
  {
    icon: 'ri-contrast-drop-2-line',
    title: '专业滤镜',
    description: '数十款精心调校的滤镜效果，从日系清新到复古胶片，从美食专用到人像优化，每款滤镜都能为照片增添独特氛围。',
  },
  {
    icon: 'ri-layout-column-line',
    title: '智能模板',
    description: '海量排版模板覆盖日常、美食、旅行、穿搭等场景，一键套用即可出片。AI智能排版引擎自动推荐最佳方案。',
  },
  {
    icon: 'ri-sticky-note-line',
    title: '创意贴纸',
    description: '丰富的贴纸素材库，支持自定义贴纸和涂鸦功能，让你的照片更加生动有趣，释放无限创意。',
  },
  {
    icon: 'ri-image-edit-line',
    title: '精准编辑',
    description: '支持裁剪、旋转、调色、锐化等专业编辑功能，蒙版工具可实现分区调整，满足精细化的修图需求。',
  },
  {
    icon: 'ri-share-forward-line',
    title: '一键分享',
    description: '编辑完成后可直接分享到微信、微博、小红书等社交平台，支持多种导出格式和高清画质保存。',
  },
];

export default function FeatureSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            为什么选择黄油相机？
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大核心功能，让每张照片都能成为艺术品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-xl mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}